(ns ycweb.app.website.trade.trade
  (:require
   [rum.core :as rum]
   [ycweb.app.website.help.article :as help-article]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.website :as website]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc trade-hero []
  [:div.header-banner.u-bg-terracotta
   [:div.header-banner__text-wrapper
    [:div.header-banner__text.u-text-white
     [:h1.header-banner__title "Trade Partners"]]]
   [:div.header-banner__image-wrapper
    [:img.header-banner__image
     {:src "https://res.cloudinary.com/yuppiechef/image/upload/w_960,f_auto/pages/trade-partner-program/yuppiechef-trade-partners-header-banner"
      :alt "Yuppiechef Trade Partner Programme"
      :width 960 :height 360
      :loading "lazy"}]]])

(rum/defc trade-intro [app-atom]
  [:div.yc-section.yc-section--medium-underline
   [:div.yc-intro-text
    (headings/heading "Get personalised service on your project"
      {:type :h2 :size :default :center true})
    [:p.yc-paragraph
     "Looking for the perfect corporate gifts or need to fit out a newly modelled kitchen for a client? If you're in the architecture and interiors, corporate relations or hospitality industries, join our trade partner program and get personalised service, advice and discounts on bulk orders from our curated range of kitchen and home products. "
     [:a.text-link.text-link--muted {:href "#js-application-form"} "Apply online"]
     "."]
    [:div.u-block-center.u-max-width-480
     [:div.flex-grid-group.flex-grid-group--flush.flex-grid-group--flush-force
      [:div.flex-grid-block.flex-grid-block--m-1-2.flex-grid-block--m-order-02
       [:div.flex-grid-content
        (buttons/button-web "Apply online"
          {:href "#js-application-form" :style :primary :full true})]]
      [:div.flex-grid-block.flex-grid-block--m-1-2
       [:div.flex-grid-content
        (buttons/button-web "How it works"
          (merge
            (help-article/article-modal-props app-atom
              {:id 167 :name "Yuppiechef-Trade-Partner-Benefits"})
            {:style :secondary :full true}))]]]]]])

(rum/defc trade-callout-1 []
  [:div.yc-section.yc-section--medium
   [:article.flex-grid-group.callout-panel
    [:div.flex-grid-block.flex-grid-block--m-1-2
     [:div.flex-grid-content
      [:div.callout-panel__hero
       [:div.u-max-width-490.yc-simple-image-wrapper.yc-simple-image-wrapper--split-2
        [:img.yc-simple-image.yc-simple-image--full.yc-simple-image--shadow.yc-simple-image--border
         {:src "https://res.cloudinary.com/yuppiechef/image/upload/w_490,f_auto/pages/trade-partner-program/yuppiechef-trade-custom-recommendation-lists"
          :alt "Split image of kitchen and tableware products"
          :width 490 :height 368
          :loading "lazy"}]]]]]
    [:div.flex-grid-block.flex-grid-block--m-1-2
     [:div.flex-grid-content
      [:div.callout-panel__content
       (headings/heading "Have a specific look you're after?"
         {:type :h2 :size :default})
       [:p.yc-paragraph
        "We know every interior project is unique — different budgets, different aesthetics, and very different client needs. So, whether you're working to a brief or a budget, we're here to help you get the job done with our unique range of small appliances and kitchenware, and everything you'll need to complete the look in other rooms with linen, towels, decor and furniture."]
       (buttons/button-web "Yes, please!"
         {:href "#js-application-form" :style :primary})]]]]])

(rum/defc trade-callout-2 []
  [:div.yc-section.yc-section--medium-underline
   [:article.flex-grid-group.callout-panel.callout-panel--hero-right
    [:div.flex-grid-block.flex-grid-block--m-1-2.flex-grid-block--m-order-02
     [:div.flex-grid-content
      [:div.callout-panel__hero
       [:div.u-max-width-490.yc-simple-image-wrapper
        [:img.yc-simple-image.yc-simple-image--full.yc-simple-image--shadow.yc-simple-image--border
         {:src "https://res.cloudinary.com/yuppiechef/image/upload/w_490,f_auto/pages/trade-partner-program/yuppiechef-trade-corporate-gift-ideas"
          :alt "A selection of Yuppiechef products that make for great gifts"
          :width 490 :height 368
          :loading "lazy"}]]]]]
    [:div.flex-grid-block.flex-grid-block--m-1-2
     [:div.flex-grid-content
      [:div.callout-panel__content
       (headings/heading "Source the perfect gift"
         {:type :h2 :size :default})
       [:p.yc-paragraph
        "Need to show your clients some love? We offer a variety of options for great corporate gifts that'll suit your industry and budget. Or, when it's too hard to decide on something specific, you can give them the gift of choice — we offer bulk Yuppiechef gift voucher solutions."]
       (buttons/button-web "Become a trade partner"
         {:href "#js-application-form" :style :primary})]]]]])

(rum/defc trade-testimonial []
  [:div.yc-section.yc-section--medium-underline
   [:aside.pinned-review
    [:p.pinned-review__quote
     "Yuppiechef combines excellent customer service with a vast range of top quality products that keeps us coming back."]
    [:small.pinned-review__author "— ARRCC Interior Design"]]])

(rum/defcs trade-form < rum/reactive (cmn/local nil ::node-atom)
  [local-atom app-atom]
  (let [node-atom (::node-atom local-atom)
        process-atom (cmn/process-cursor app-atom)
        form-atom (rum/cursor process-atom :trade-form)
        action-atom (cmn/action-cursor app-atom)
        industries (cmn/curact action-atom :trade-industries)
        captcha-site-key (:captcha-site-key (cmn/curact app-atom :config))
        newsletter-atom (rum/cursor form-atom :newslettersubscribe)
        promotion-atom (rum/cursor form-atom :promotionsubscribe)
        newsletter-on? (rum/react newsletter-atom)]
    [:div#js-application-form.yc-section.yc-section--large
     (headings/heading "Apply to become a Trade customer"
       {:type :h2 :size :default :center true})
     [:form.form.u-block-center.comp-form.u-max-width-480
      {:ref (fn [node] (reset! node-atom node))
       :on-submit (fn [e] (.preventDefault e))}
      [:div.form-field.js-form-field
       (forms/split-input-field
         ["First name:" "e.g. Jane" (rum/cursor form-atom :firstname) {:required? true :id "firstname"}]
         ["Last name:" "e.g. Smith" (rum/cursor form-atom :lastname) {:required? true :id "lastname"}])]
      [:div.form-field.js-form-field
       (forms/input "Company name:" "e.g. Smith Co. Interiors"
         (rum/cursor form-atom :company)
         {:required? true :id "company"})]
      [:div.form-field
       [:label.form-label {:for "trade"} "Industry:"]
       (forms/select ""
         (rum/cursor form-atom :trade)
         (concat
           [{:text "- Select -" :value ""}]
           (map
             (fn [{:keys [id name]}]
               {:text name :value (str id)})
             industries))
         {:required? true :id "trade"})]
      [:div.form-field.js-form-field
       (forms/input "Email address:" "e.g. jane.smith@domain.com"
         (rum/cursor form-atom :email)
         {:required? true :type "email" :id "email"})]
      [:div.form-field
       (forms/textarea "Physical address:"
         (rum/cursor form-atom :physical)
         {:id "physical"})]
      [:div.form-field
       (forms/toggle "Newsletters and personalised offers"
         newsletter-atom
         {:id "newslettersubscribe"
          :description "Find out first about new launches and deals, plus the chance to receive occasional vouchers"
          :on-change
          (fn [_]
            (let [new-val (not @newsletter-atom)]
              (reset! newsletter-atom new-val)
              (when new-val
                (reset! promotion-atom true))))})]
      [:div.form-field.js-form-field
       (forms/toggle "Personalised offers only"
         promotion-atom
         {:id "promotionsubscribe"
          :disabled newsletter-on?
          :description "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"})]
      [:div.form-control
       (buttons/button-web "Submit application"
         (merge
           (urlstate/href-on-click
             (forms/form-validate node-atom
               #(appcommon/recaptcha app-atom captcha-site-key :web.trade/submit nil)))
           {:type :button :style :dark}))]
      [:p.yc-paragraph.yc-paragraph--small
       [:a.text-link.text-link--muted
        (help-article/article-modal-props app-atom
          {:id 167 :name "Yuppiechef-Trade-Partner-Benefits"})
        "Terms and conditions"]]]]))

(rum/defc trade-thanks []
  [:div
   [:div.header-banner.header-banner--no-image.u-bg-terracotta
    [:div.header-banner__text-wrapper
     [:div.header-banner__text.u-text-white
      [:h1.header-banner__title "Trade Partners"]]]]
   [:div.yc-section.yc-section--large
    [:div.yc-intro-text
     [:div.u-max-width-640.u-block-center
      (headings/heading "Thank you for your application"
        {:type :h1 :size :large :center true})
      [:p.yc-paragraph
       "Our team will review your application shortly. If your application is successful, we'll email you with further details. If we have any questions or further information we need from you, we'll be sure to contact you."]
      (buttons/button-web "Start Shopping"
        (merge (urlstate/href-props nil "index" nil) {:style :dark}))]]]])

(rum/defc trade-page < rum/reactive [app-atom]
  (let [submitted? (cmn/curact (cmn/process-cursor app-atom) :trade-submitted)]
    (if submitted?
      (trade-thanks)
      [:div
       (trade-hero)
       (trade-intro app-atom)
       (trade-callout-1)
       (trade-callout-2)
       (trade-testimonial)
       (trade-form app-atom)])))

(defmethod flow/render-screen :web.trade [app-atom _]
  (website/screen-wrapper app-atom
    (trade-page app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.trade [app-atom _ _]
  (toaster/open-overlay app-atom :web.trade)
  (comms/ajax-get :web.trade/page {}))

(defmethod comms/receive :web.trade/page [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc :trade-industries (:industries e))
  (toaster/close-overlay app-atom :web.trade))

(defmethod grid/action :web.trade/submit [app-atom config _]
  (toaster/open-toast app-atom :processing "Submitting application" {:closetime 5000})
  (let [form-data (cmn/curact (cmn/process-cursor app-atom) :trade-form)]
    (comms/ajax-post :web.trade/apply
      (assoc form-data :captcha-token (:captcha-token config)))))

(defmethod comms/receive :web.trade/apply [app-atom res]
  (toaster/close-toast app-atom)
  (if (:success res)
    (swap! (cmn/process-cursor app-atom) assoc :trade-submitted true)
    (grid/open-modal app-atom :web.trade/error
      {:config {:message (or (:msg res) "Something went wrong.")}})))

(defmethod grid/modal-config :web.trade/error [_ _ _]
  {:body-raw
   (fn [app-atom config-atom]
     (let [message (cmn/curact config-atom [:config :message])]
       [:div.yc-popup.yc-popup--has-footer
        [:div.yc-popup__content
         [:p message]]]))
   :modal-type :alert})

(defmethod flow/render-screen :web.trade-thanks [app-atom _]
  (website/screen-wrapper app-atom
    (trade-thanks)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.trade-thanks [app-atom _ _]
  nil)
